import React from "react";
import HindiData from "../../utils/EkadaData.js"; 
import { ColorArray } from "../../config/ColorArray";
import "./EkadaData.css";
import SectionDivider from "../../common/SectionDivider";
const HindiAkdaData = () => {
    return (
            <>
        <SectionDivider title="હિન્દી એકડા" />
        <div className="ekada-grid">
            {HindiData.map((item, index) => {
                const color = ColorArray[index % ColorArray.length]?.color2;

                return (
                    <div className="ekada-card" key={index}>
                        
                        {/* HINDI NUMBER (BIG) */}
                        <div className="ekada-number" style={{ color }}>
                            {item.hindi_number}
                        </div>

                        {/* TEXT BLOCK */}
                        <div className="ekada-text">

                            {/* HINDI TITLE */}
                            <h2 className="ekada-title" style={{ color }}>
                                {item.hindi_title}
                            </h2>

                            {/* GUJARATI TITLE */}
                            <p className="ekada-guj" style={{ color }}>{item.gujarati_title}</p>

                            {/* ENGLISH TITLE */}
                            <p className="ekada-eng" style={{ color }}>{item.english_title}</p>
                        </div>
                    </div>
                );
            })}
        </div>
        </>
    );
};

export default HindiAkdaData;
